import React from 'react';
import { array, bool, object } from 'prop-types';
import AmpUnzippedGallery from 'components/AmpUnzippedGallery';
import { GALLERY_AD_OFFSET_AMP } from 'constants/ads/injector';

// CLEANUP If we continue to only use the unzipped version we can
// get rid of this HOC
function AmpGallery(props) {
  if (props.images.length > 0) {
    return (
      <AmpUnzippedGallery
        {...props}
        adOffset={props.hideAds ? undefined : GALLERY_AD_OFFSET_AMP}
      />
    );
  }
  return null;
}

AmpGallery.propTypes = {
  images: array.isRequired, // eslint-disable-line react/forbid-prop-types
  post: object, // eslint-disable-line react/forbid-prop-types
  hideAds: bool
};

AmpGallery.defaultProps = {
  post: {},
  hideAds: false
};

export default AmpGallery;
